var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.009,
    height: 35.015,
    viewBox: "0 0 24.009 35.015",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pin",
    d: "M850.445,1205.378c-.467-.548-11.446-13.546-11.446-22.034a12.009,12.009,0,1,1,24.008,0c.037,8.491-11.015,21.489-11.487,22.038l-.538.629Zm-10.034-22.034c0,6.947,8.352,17.727,10.575,20.471,2.234-2.742,10.639-13.522,10.609-20.467a10.6,10.6,0,1,0-21.184,0Zm5.447-.392a5.145,5.145,0,1,1,5.145,5.125A5.142,5.142,0,0,1,845.858,1182.952Zm1.413,0a3.732,3.732,0,1,0,3.732-3.718A3.728,3.728,0,0,0,847.271,1182.952Z",
    transform: "translate(-838.999 -1170.995)",
    fill: "#235677"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.e1f1a76386dc2cbbc47361f56c67397a.svg";
export { ForwardRef as ReactComponent };